import Vue from "vue";
import VueRouter from "vue-router";
import goTo from 'vuetify/lib/services/goto';
import homePage from "@/Academy/Pages/HomePage";
import ProductsList from "@/Academy/Pages/ProductsList";
import ProductCategories from "@/Academy/Pages/ProductCategories";
import ProductDetail from "@/Academy/Pages/ProductDetail";
import ArticlesList from "@/Academy/Pages/ArticlesList";
import EventsList from "@/Academy/Pages/EventsList";
import NewsesList from "@/Academy/Pages/NewsesList";
import ContentDetail from "@/Academy/Pages/ContentDetail";
import Cart from "@/Academy/Pages/Cart";
import Certificates from "@/Academy/Pages/Certificates";
import AboutUs from "@/Academy/Pages/AboutUs";
import ConnectUs from "@/Academy/Pages/ConnectUs";
import RulesOfRegulation from "@/Academy/Pages/RulesOfRegulation";
import EditProfile from "@/Academy/Pages/Profile/EditProfile";
import OrdersRecords from "@/Academy/Pages/Profile/OrdersRecords";
import Services from "@/Academy/Pages/Services";
import CommentsAndComplaints from "@/Academy/Pages/CommentsAndComplaints";
import AdminLogin from "@/Admin/Pages/AdminLogin";
import allProducts from "@/Academy/Pages/allProducts";
import manageAddress from "@/Academy/Pages/manageAddress";
import listAddress from "@/Academy/Pages/listAddress";
import searchResult from "@/Academy/Pages/searchResult";

Vue.use(VueRouter);

const routes = [
    {
        path: "/HomePage",
        name: "خانه",
        component: homePage,
    },
    {
        path: '/',
        redirect: '/HomePage',
    },
    {
        path: "/ProductsList",
        name: "لیست محصولات",
        component: ProductsList,
    },
    {
        path: "/ProductCategories",
        name: "دسته بندی محصولات",
        component: ProductCategories,
    },
    {
        path: "/listAddress",
        name: "لیست آدرس ها",
        component: listAddress,
    },
    {
        path: "/searchResult",
        name: "نتایج جستجو",
        component: searchResult,
    },
    {
        path: "/manageAddress",
        name: "مدیریت آدرس ها",
        component: manageAddress,
    },
    {
        path: "/ProductDetail",
        name: "جرئیات محصول",
        component: ProductDetail,
    },
    {
        path: "/ArticlesList",
        name: "لیست مقالات",
        component: ArticlesList,
    },
    {
        path: "/allProducts",
        name: "همه محصولات",
        component: allProducts,
    },
    {
        path: "/EventsList",
        name: "لیست رویدادها",
        component: EventsList,
    },
    {
        path: "/NewsesList",
        name: "لیست اخبار",
        component: NewsesList,
    },
    {
        path: "/ContentDetail",
        name: "جرئیات محتوا",
        component: ContentDetail,
    },
    {
        path: "/Cart",
        name: "سبد خرید",
        component: Cart,
    },
    {
        path: "/Certificates",
        name: "مدارک",
        component: Certificates,
    },
    {
        path: "/AboutUs",
        name: "درباره ما",
        component: AboutUs,
    },
    {
        path: "/ConnectUs",
        name: "تماس با ما",
        component: ConnectUs,
    },
    {
        path: "/RulesOfRegulation",
        name: "قوانین و مقررات",
        component: RulesOfRegulation,
    },
    {
        path: "/EditProfile",
        name: "ویرایش پروفایل",
        component: EditProfile,
    },
    {
        path: "/OrdersRecords",
        name: "سوابق سفارشات",
        component: OrdersRecords,
    },
    {
        path: "/Services",
        name: "خدمات",
        component: Services,
    },
    {
        path: "/CommentsAndComplaints",
        name: "نظرات و شکایات",
        component: CommentsAndComplaints,
    },
    {
        path: "/AdminLogin",
        name: "AdminLogin",
        component: AdminLogin,
    },
    {
        path: "/Dashboard",
        name: "پنل مدیریت",
        component: () => import('@/Admin/Pages/Dashboard'),
        children: [
            {
                name: 'تعریف بنر',
                path: '/Dashboard/DefineBanner',
                component: () => import('@/Admin/Pages/DefineBanner'),
            },
            {
                name: 'لیست بنرها',
                path: '/Dashboard/BannersList',
                component: () => import('@/Admin/Pages/BannersList'),
            },
            {
                name: 'تعریف دسته بندی فروشگاه',
                path: '/Dashboard/DefineStoreCategories',
                component: () => import('@/Admin/Pages/DefineStoreCategories'),
            },
            {
                name: 'لیست دسته بندی فروشگاه',
                path: '/Dashboard/StoreCategoriesList',
                component: () => import('@/Admin/Pages/StoreCategoriesList'),
            },
            {
                name: 'تعریف اعضا',
                path: '/Dashboard/DefineUser',
                component: () => import('@/Admin/Pages/DefineUser'),
            },
            {
                name: 'دسته بندی اخبار',
                path: '/Dashboard/listNewsCategory',
                component: () => import('@/Admin/Pages/listNewsCategory'),
            },
            {
                name: 'لیست اعضا',
                path: '/Dashboard/UsersList',
                component: () => import('@/Admin/Pages/UsersList'),
            },
            {
                name: 'تعریف محصول',
                path: '/Dashboard/DefineProduct',
                component: () => import('@/Admin/Pages/DefineProduct'),
            },
            {
                name: 'لیست محصول',
                path: '/Dashboard/ProductsList',
                component: () => import('@/Admin/Pages/ProductsList'),
            },
            {
                name: 'لیست کدتخیف ها',
                path: '/Dashboard/DiscountCodesList',
                component: () => import('@/Admin/Pages/DiscountCodesList'),
            },
            {
                name: 'تعریف کدتخیف',
                path: '/Dashboard/DefineDiscountCode',
                component: () => import('@/Admin/Pages/DefineDiscountCode'),
            },
            {
                name: 'تعریف مدارک و تحصیلات',
                path: '/Dashboard/DefineCertificate',
                component: () => import('@/Admin/Pages/DefineCertificate'),
            },
            {
                name: 'لیست مدارک و تحصیلات',
                path: '/Dashboard/CertificatesList',
                component: () => import('@/Admin/Pages/CertificatesList'),
            },
            {
                name: 'لیست دسته بندی ها',
                path: '/Dashboard/ContentCategoriesList',
                component: () => import('@/Admin/Pages/ContentCategoriesList'),
            },
            {
                name: 'تعریف دسته بندی',
                path: '/Dashboard/DefineContentCategory',
                component: () => import('@/Admin/Pages/DefineContentCategory'),
            },
            {
                name: 'تعریف خبر',
                path: '/Dashboard/DefineNews',
                component: () => import('@/Admin/Pages/DefineNews'),
            },
            {
                name: 'دسته بندی خبر',
                path: '/Dashboard/defineNewsCategory',
                component: () => import('@/Admin/Pages/defineNewsCategory'),
            },
            {
                name: 'لیست اخبار',
                path: '/Dashboard/NewsesList',
                component: () => import('@/Admin/Pages/NewsesList'),
            },
            {
                name: 'لیست مقالات',
                path: '/Dashboard/ArticlesList',
                component: () => import('@/Admin/Pages/ArticlesList'),
            },
            {
                name: 'تعریف مقاله',
                path: '/Dashboard/DefineArticle',
                component: () => import('@/Admin/Pages/DefineArticle'),
            },
            {
                name: 'دسته بندی رویداد',
                path: '/Dashboard/defineEventsCategory',
                component: () => import('@/Admin/Pages/defineEventsCategory'),
            },
            {
                name: 'لیست دسته بندی رویداد',
                path: '/Dashboard/listEventsCategory',
                component: () => import('@/Admin/Pages/listEventsCategory'),
            },
            {
                name: 'تعریف رویداد',
                path: '/Dashboard/DefineEvent',
                component: () => import('@/Admin/Pages/DefineEvent'),
            },
            {
                name: 'لیست رویدادها',
                path: '/Dashboard/EventsList',
                component: () => import('@/Admin/Pages/EventsList'),
            },
            {
                name: 'لیست صفحات',
                path: '/Dashboard/PagesList',
                component: () => import('@/Admin/Pages/PagesList'),
            },
            {
                name: 'تعریف صفحه',
                path: '/Dashboard/DefinePage',
                component: () => import('@/Admin/Pages/DefinePage'),
            },
            {
                name: 'لیست شبکه های اجتماعی',
                path: '/Dashboard/SocialMediasList',
                component: () => import('@/Admin/Pages/SocialMediasList'),
            },
            {
                name: 'تعریف شبکه اجتماعی',
                path: '/Dashboard/DefineSocialMedia',
                component: () => import('@/Admin/Pages/DefineSocialMedia'),
            },
            {
                name: 'لیست خدمات',
                path: '/Dashboard/ServicesList',
                component: () => import('@/Admin/Pages/ServicesList'),
            },
            {
                name: 'تعریف خدمات',
                path: '/Dashboard/DefineService',
                component: () => import('@/Admin/Pages/DefineService'),
            },
            {
                name: 'گزارش  ',
                path: '/Dashboard/FinancialReport',
                component: () => import('@/Admin/Pages/FinancialReport'),
            },
            {
                name: 'لیست منطقه ',
                path: '/Dashboard/listArea',
                component: () => import('@/Admin/Pages/listArea'),
            },
            {
                name: 'لیست کشور ',
                path: '/Dashboard/listCountries',
                component: () => import('@/Admin/Pages/listCountries'),
            },
            {
                name: 'لیست محله ',
                path: '/Dashboard/listDistricts',
                component: () => import('@/Admin/Pages/listDistricts'),
            },
            {
                name: 'لیست استان ',
                path: '/Dashboard/listProvince',
                component: () => import('@/Admin/Pages/listProvince'),
            },
            {
                name: 'لیست شهر ',
                path: '/Dashboard/listTowns',
                component: () => import('@/Admin/Pages/listTowns'),
            },
            {
                name: 'لیست شهرستان ',
                path: '/Dashboard/listCities',
                component: () => import('@/Admin/Pages/listCities'),
            },
            {
                name: 'تعریف منطقه ',
                path: '/Dashboard/defineArea',
                component: () => import('@/Admin/Pages/defineArea'),
            },
            {
                name: 'تعریف شهرستان ',
                path: '/Dashboard/defineCity',
                component: () => import('@/Admin/Pages/defineCity'),
            },
            {
                name: 'تعریف کشور ',
                path: '/Dashboard/defineCountry',
                component: () => import('@/Admin/Pages/defineCountry'),
            },
            {
                name: 'تعریف محله ',
                path: '/Dashboard/defineDistrict',
                component: () => import('@/Admin/Pages/defineDistrict'),
            },
            {
                name: 'تعریف استان ',
                path: '/Dashboard/defineProvince',
                component: () => import('@/Admin/Pages/defineProvince'),
            },
            {
                name: 'تعریف شهر ',
                path: '/Dashboard/defineTown',
                component: () => import('@/Admin/Pages/defineTown'),
            },
            {
                name: 'دسته بندی مقالات ',
                path: '/Dashboard/defineArticleCategory',
                component: () => import('@/Admin/Pages/defineArticleCategory'),
            },
            {
                name: 'لیست دسته بندی مقالات ',
                path: '/Dashboard/listArticleCategory',
                component: () => import('@/Admin/Pages/listArticleCategory'),
            },
            {
                name: 'صفحات خاص ',
                path: '/Dashboard/DefineSpecificPage',
                component: () => import('@/Admin/Pages/DefineSpecificPage'),
            },
            {
                name: 'لیست صفحات خاص ',
                path: '/Dashboard/listSpecificPages',
                component: () => import('@/Admin/Pages/listSpecificPages'),
            },
            {
                name: 'تعریف آدرس',
                path: '/Dashboard/defineAddress',
                component: () => import('@/Admin/Pages/defineAddress'),
            },
            {
                name: 'لیست آدرس',
                path: '/Dashboard/addressList',
                component: () => import('@/Admin/Pages/addressList'),
            },
            {
                name: 'انتقادات و پیشنهادات',
                path: '/Dashboard/suggestionAndCritics',
                component: () => import('@/Admin/Pages/suggestionAndCritics'),
            },

        ]
    },
];


const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0

        if (to.hash) {
            scrollTo = to.hash
        } else if (savedPosition) {
            scrollTo = savedPosition.y
        }

        return goTo(scrollTo)
    },
    routes,
});


export default router;
